import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../../services/auth/auth-service';
import {UserService} from '../../services/user/user.service';
import {RETURN_URL_PARAM} from '../../helpers/return-url.helper';


@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate, CanActivateChild {
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkUserAccess(state);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkUserAccess(state);
  }

  private async checkUserAccess(state: RouterStateSnapshot): Promise<boolean> {
    if (!this.authService.isAuthenticated()) {
      // L'indirizzo richiesto viaggia verso il login, che dopo l'accesso lo
      // riapre (se l'utente è autorizzato): un link condiviso porta così alla
      // pagina, filtri compresi, e non alla home. La home è già la
      // destinazione di default e non serve portarla.
      const destinazione = state.url;
      const versoHome = destinazione === '/' || destinazione.split('?')[0] === '/home';
      this.router.navigate(['login'], versoHome ? {} : {queryParams: {[RETURN_URL_PARAM]: destinazione}});
      return false;
    }

    // Assicuriamoci che i dati utente siano stati caricati
    await this.userService.fetchUserInfo();

    const currentUser = this.userService.currentUser();
    if (currentUser?.primoAccesso) {
      // Se l'utente è in primo accesso, blocca qualsiasi navigazione al di fuori di home
      const targetUrl = state.url.split('?')[0];
      if (targetUrl !== '/home' && targetUrl !== '/' && targetUrl !== '/login') {
        this.router.navigate(['home']);
        return false;
      }
    }

    return true;
  }
}
